import { Action, createAction, createAsyncAction, createReducer } from 'typesafe-actions';
import { produce } from 'immer';
import { AllFilters } from '@appTypes/carFiltersType';

// Actions
export enum Actions {
  GET_CAR_ARGUMENTS = 'naf/carFilter/GET_CAR_ARGUMENTS',
  GET_CAR_ARGUMENTS_SUCCESS = 'naf/carFilter/GET_CAR_ARGUMENTS_SUCCESS',
  GET_CAR_ARGUMENTS_FAIL = 'naf/carFilter/GET_CAR_ARGUMENTS_FAIL',
  GET_CAR_ARGUMENTS_CANCEL = 'naf/carFilter/GET_CAR_ARGUMENTS_CANCEL',
  PURGE_FILTER = 'naf/carFilter/PURGE_FILTER',
  REFRESH_SEARCH = 'naf/carFilter/REFRESH_SEARCH',
  SET_DID_REFRESH_SEARCH = 'naf/carFilter/SET_DID_REFRESH_SEARCH',
  SET_SELECTED_VARIANTS = 'naf/carFilter/SET_SELECTED_VARIANTS',
}

export interface State {
  allFilters: AllFilters;
  sortBy?: string;
  isFetchingFilters: boolean;
  errorState: string | null;
  filterNumber: number;
  filterFetched: boolean;
  selectedVariants: string[];
}

export const initialState: State = {
  allFilters: {},
  isFetchingFilters: false,
  errorState: null,
  filterNumber: 1,
  filterFetched: false,
  selectedVariants: [],
};
export const actions = {
  getCarArguments: createAsyncAction(
    Actions.GET_CAR_ARGUMENTS, // request payload creator
    Actions.GET_CAR_ARGUMENTS_SUCCESS, // success payload creator
    Actions.GET_CAR_ARGUMENTS_FAIL, // failure payload creator
    Actions.GET_CAR_ARGUMENTS_CANCEL, // optional cancel payload creator
  )<string, AllFilters, string, undefined>(),
  refreshSearch: createAction(Actions.REFRESH_SEARCH)(),
  setDidRefreshSearch: createAction(Actions.SET_DID_REFRESH_SEARCH)(),
  setSelectedVariants: createAction(Actions.SET_SELECTED_VARIANTS)<string[]>(),
};

export const reducers = createReducer<State, Action>(initialState, {})
  .handleAction(actions.getCarArguments.request, (state: State = initialState) =>
    produce(state, (draftState) => {
      draftState.isFetchingFilters = true;
    }),
  )
  .handleAction(actions.getCarArguments.success, (state: State = initialState, action) =>
    produce(state, (draftState) => {
      draftState.allFilters = action.payload;
      draftState.isFetchingFilters = false;
    }),
  )
  .handleAction(actions.getCarArguments.failure, (state: State = initialState, action) =>
    produce(state, (draftState) => {
      draftState.isFetchingFilters = false;
      draftState.errorState = action.payload;
    }),
  )
  .handleAction(actions.getCarArguments.cancel, (state: State = initialState) =>
    produce(state, (draftState) => {
      draftState.isFetchingFilters = false;
    }),
  )
  .handleAction(actions.refreshSearch, (state: State = initialState) =>
    produce(state, (draftState) => {
      draftState.filterNumber += 1;
      draftState.filterFetched = false;
    }),
  )
  .handleAction(actions.setDidRefreshSearch, (state: State = initialState) =>
    produce(state, (draftState) => {
      draftState.filterFetched = true;
    }),
  )
  .handleAction(actions.setSelectedVariants, (state: State = initialState, action) =>
    produce(state, (draftState) => {
      draftState.selectedVariants = action.payload;
    }),
  );
